export const common = {
  // Navigation
  'nav.home': 'Início',
  'nav.spreadsheet': 'CSSBuy Spreadsheet',
  'nav.categories': 'Categorias',
  'nav.guides': 'Guias',
  'nav.review': 'Review',
  'nav.shipping': 'Frete',
  'nav.safety': 'Segurança',
  'nav.language': 'Idioma',
  'nav.visitMain': 'Visitar Site Principal',
  'nav.products': 'Produtos',

  // Hero
  'hero.eyebrow': 'CSSBuy Spreadsheet 2026',
  'hero.title': 'CSSBuy Spreadsheet: Encontre, Compare e Organize Produtos CSSBuy em um Só Lugar',
  'hero.subtitle': 'Encontre planilhas, produtos, categorias e guias CSSBuy em um só lugar. Compare opções, consulte informações sobre QC, warehouse e envio e descubra recursos úteis para pesquisar antes de comprar.',
  'hero.ctaPrimary': 'Explorar CSSBuy Spreadsheet',
  'hero.ctaSecondary': 'Ver Guia para Iniciantes',
  'hero.ctaMain': 'Visitar Site Principal',
  'hero.trust': 'Recurso independente • Guias práticos • Comparações • Português, English e Deutsch',

  // Search
  'search.title': 'Encontre rapidamente o que você procura',
  'search.placeholder': 'Pesquisar CSSBuy Spreadsheet, tênis, hoodies, QC, envio...',
  'search.filters': 'Spreadsheet / Produtos / QC / Shipping / Guias / Reviews / Cupons',

  // Quick Links
  'quick.spreadsheet': 'Spreadsheet',
  'quick.products': 'Produtos',
  'quick.qc': 'QC',
  'quick.shipping': 'Envio',
  'quick.guides': 'Guias',
  'quick.reviews': 'Reviews',
  'quick.coupons': 'Cupons',

  // Categories
  'categories.title': 'Explore o CSSBuy Spreadsheet por categoria',
  'categories.cta': 'Ver todas as categorias',

  // Value Proposition
  'value.title': 'Tudo o que você precisa para pesquisar melhor',
  'value.find': 'Encontre mais rápido',
  'value.findDesc': 'Recursos organizados para facilitar a pesquisa.',
  'value.compare': 'Compare opções',
  'value.compareDesc': 'Tabelas e guias para comparar informações.',
  'value.process': 'Entenda o processo',
  'value.processDesc': 'Conteúdo sobre produtos, QC, warehouse e shipping.',
  'value.safety': 'Mais segurança',
  'value.safetyDesc': 'Aprenda a identificar links suspeitos e informações desatualizadas.',
  'value.lang': 'Multilíngue',
  'value.langDesc': 'Português, English e Deutsch.',

  // Featured
  'featured.title': 'CSSBuy Spreadsheet: recursos em destaque',
  'featured.cta': 'Ver recurso',

  // Review
  'review.title': 'CSSBuy Review: o que você precisa saber',
  'review.text': 'Antes de utilizar qualquer serviço de compra internacional, é importante entender produtos, warehouse, QC, envio, pagamentos e riscos. Nosso CSSBuy Review reúne os principais pontos para facilitar sua pesquisa.',
  'review.cta': 'Ler CSSBuy Review',

  // Shipping
  'shipping.title': 'CSSBuy Shipping Cost: entenda os custos de envio',
  'shipping.text': 'O custo de envio pode variar conforme peso, volume, destino, método e condições atuais. Sempre confirme os valores disponíveis antes de finalizar uma compra.',
  'shipping.cta': 'Ver CSSBuy Shipping Cost',

  // Safety
  'safety.title': 'CSSBuy Safety: pesquise com mais segurança',
  'safety.text': 'Links podem ficar desatualizados, preços podem mudar e páginas falsas podem tentar imitar serviços legítimos. Aprenda a verificar URLs, proteger sua conta e evitar links suspeitos.',
  'safety.cta': 'Visitar Safety Center',

  // FAQ
  'faq.title': 'Perguntas Frequentes — CSSBuy Spreadsheet',
  'faq.q1': 'O que é CSSBuy Spreadsheet?',
  'faq.a1': 'CSSBuy Spreadsheet é um recurso organizado que reúne links, produtos, categorias e informações úteis para quem utiliza a plataforma CSSBuy. Ele facilita a pesquisa e comparação de produtos antes de comprar.',
  'faq.q2': 'Como usar um CSSBuy Spreadsheet?',
  'faq.a2': 'Abra a planilha, navegue pelas categorias de produtos, verifique os links e informações de QC, compare preços e leia as guias de envio antes de fazer uma compra.',
  'faq.q3': 'Onde encontrar links CSSBuy?',
  'faq.a3': 'Links CSSBuy podem ser encontrados em planilhas organizadas, fóruns de comunidade, guias especializados e recursos independentes como este site.',
  'faq.q4': 'O que significa W2C?',
  'faq.a4': 'W2C significa "Where To Cop" — é uma expressão comum em comunidades de compras que indica onde encontrar um produto específico.',
  'faq.q5': 'Como verificar produtos?',
  'faq.a5': 'Verifique fotos de QC (Quality Control), leia descrições detalhadas, compare com imagens oficiais e consulte reviews da comunidade antes de comprar.',
  'faq.q6': 'CSSBuy é legítimo?',
  'faq.a6': 'CSSBuy é uma plataforma conhecida de agente de compras. Como qualquer serviço internacional, é importante pesquisar, verificar URLs oficiais e entender os riscos antes de usar.',

  // Final CTA
  'finalCta.title': 'Pronto para explorar o CSSBuy Spreadsheet?',
  'finalCta.text': 'Comece pelos recursos mais populares, compare categorias e consulte nossos guias antes de continuar sua pesquisa.',
  'finalCta.explore': 'Explorar CSSBuy Spreadsheet',
  'finalCta.visit': 'Visitar Site Principal',
  'finalCta.disclaimer': 'Este é um recurso independente e não é afiliado, patrocinado ou oficialmente endossado pela CSSBuy.',

  // Footer
  'footer.spreadsheet': 'CSSBuy Spreadsheet',
  'footer.guides': 'Guias',
  'footer.categories': 'Categorias',
  'footer.comparisons': 'Comparações',
  'footer.safety': 'Segurança',
  'footer.about': 'Sobre',
  'footer.legal': 'Legal',
  'footer.languages': 'Idiomas',
  'footer.disclaimer': 'CSSBuyBR.TOP é um recurso independente e não é afiliado, patrocinado ou oficialmente endossado pela CSSBuy.',
  'footer.privacy': 'Política de Privacidade',
  'footer.terms': 'Termos de Uso',
  'footer.disclaimerLink': 'Disclaimer',
  'footer.contact': 'Contato',

  // Articles
  'articles.title': 'Artigos e Guias CSSBuy Spreadsheet',
  'articles.readMore': 'Ler artigo',
  'articles.readTime': 'min de leitura',

  // Category Buttons
  'cat.shoes': 'Shoes',
  'cat.hoodies': 'Hoodies/Sweaters',
  'cat.tshirts': 'T-Shirts',
  'cat.jackets': 'Jackets',
  'cat.pants': 'Pants/Shorts',
  'cat.headwear': 'Headwear',
  'cat.sets': 'Sets',
  'cat.underwear': 'Underwear/Underpants',
  'cat.jersey': 'Jersey',
  'cat.accessories': 'Accessories',
  'cat.bags': 'Bags',
  'cat.belts': 'Belts',
  'cat.perfumes': 'Perfumes',
  'cat.other': 'Other Stuff',

  // Buttons
  'btn.cssbuySpreadsheet': 'CSSBuy Spreadsheet',
  'btn.buyItNow': 'Buy It Now',
  'btn.explore': 'Explorar',
  'btn.readMore': 'Ler mais',
  'btn.backToHome': 'Voltar ao início',

  // Products
  'products.title': 'Produtos CSSBuy Spreadsheet',
  'products.subtitle': 'Encontre os melhores produtos do CSSBuy Spreadsheet em todas as categorias. Clique em qualquer item para comprar no site principal.',
  'products.buyNow': 'Comprar Agora',
  'products.allCategories': 'Todas as Categorias',
  'products.count': 'produtos',
  'products.noProducts': 'Nenhum produto encontrado nesta categoria.',
  'products.featuredTitle': 'Produtos em Destaque',
  'products.viewAll': 'Ver todos os produtos',

  // Content Page
  'content.relatedPages': 'Páginas Relacionadas',
  'article.disclaimerExtra': 'Este artigo é apenas para fins informativos. Sempre verifique as informações atuais diretamente nas fontes oficiais antes de tomar quaisquer decisões de compra.',
  'content.tableOfContents': 'Índice',
  'content.continueShopping': 'Continuar Comprando',
  'content.visitMain': 'Visitar Site Principal',
  'content.relatedResources': 'Recursos Relacionados',
  'content.backToHome': 'Voltar ao Início',
  'content.spreadsheetHub': 'Hub CSSBuy Spreadsheet',
  'content.shippingCostGuide': 'Guia de Custo de Envio',
  'content.browseCategories': 'Navegar por Categorias',
  'content.disclaimer': 'Isenção de Responsabilidade',
  'content.published': 'Publicado',
  'content.updated': 'Atualizado',
  'content.by': 'Por',

  // Hero Card
  'hero.cardTitle': 'CSSBuy Spreadsheet',
  'hero.organizedResources': 'Recursos Organizados de Produtos',
  'hero.categoriesCount': '14 categorias',
  'hero.viewAll': 'Ver todos',

  // Articles
  'articles.viewAll': 'Ver todos',

  // Home CTA
  'home.cta.description': 'Explore o catálogo completo de produtos CSSBuy e encontre os melhores itens disponíveis agora.',

  // Not Found
  'notFound.title': 'Página não encontrada',
  'notFound.path': 'Caminho',
  'notFound.description': 'Esta página não foi encontrada. Volte para a página inicial ou explore nossos recursos.',

  // Footer
  'footer.warehouse': 'CSSBuy Warehouse',
  'footer.coupon': 'CSSBuy Coupon',
  'footer.legit': 'CSSBuy é Legítimo?',
  'footer.faq': 'FAQ',

  // Contact
  'contact.title': 'Contato',
  'contact.contactUs': 'Fale Conosco',
  'contact.messageSent': 'Mensagem Enviada',
  'contact.thankYou': 'Obrigado por entrar em contato. Responderemos em breve.',
  'contact.sendAnother': 'Enviar outra mensagem',
  'contact.sendMessage': 'Enviar Mensagem',
  'contact.name': 'Nome',
  'contact.email': 'Email',
  'contact.subject': 'Assunto',
  'contact.message': 'Mensagem',
  'contact.maxChars': 'Máximo 500 caracteres',
  'contact.description': 'Tem dúvidas, feedback ou sugestões? Entre em contato e responderemos o mais breve possível.',

  // FAQ
  'faq.stillQuestions': 'Ainda tem dúvidas?',
  'faq.exploreMore': 'Explore mais recursos no site principal ou entre em contato conosco.',
  'faq.contactBtn': 'Fale Conosco',
  'faq.description': 'Encontre respostas para perguntas comuns sobre CSSBuy, planilhas, produtos, envio e segurança.',

  // Products
  'products.eyebrow': 'CSSBuy Spreadsheet 2026',

  // About
  'about.title': 'Sobre CSSBuyBR.TOP',
  'about.whatWeDo': 'O que fazemos',
  'about.independence': 'Nossa Independência',
  'about.contentPolicy': 'Política de Conteúdo',
  'about.languages': 'Idiomas',
  'about.disclaimer': 'Isenção de Responsabilidade',
  'about.primary': 'Idioma principal',
  'about.international': 'Internacional',
  'about.german': 'Alemão',

  // Privacy
  'privacy.info': 'Informações que Coletamos',
  'privacy.use': 'Como Usamos as Informações',
  'privacy.cookies': 'Cookies',
  'privacy.thirdParty': 'Links de Terceiros',
  'privacy.security': 'Segurança dos Dados',
  'privacy.changes': 'Alterações nesta Política',
  'privacy.contact': 'Contato',

  // Terms
  'terms.acceptance': 'Aceitação dos Termos',
  'terms.independent': 'Recurso Independente',
  'terms.accuracy': 'Precisão do Conteúdo',
  'terms.noGuarantees': 'Sem Garantias',
  'terms.external': 'Links Externos',
  'terms.ip': 'Propriedade Intelectual',
  'terms.liability': 'Limitação de Responsabilidade',
  'terms.changes': 'Alterações dos Termos',
  'terms.governing': 'Lei Aplicável',

  // Disclaimer
  'disclaimer.independent': 'Recurso Independente',
  'disclaimer.noAffiliation': 'Sem Afiliação Oficial',
  'disclaimer.accuracy': 'Precisão das Informações',
  'disclaimer.noAdvice': 'Sem Aconselhamento Profissional',
  'disclaimer.external': 'Links Externos e Riscos',
  'disclaimer.responsibility': 'Responsabilidade do Usuário',
  'disclaimer.liability': 'Limitação de Responsabilidade',
  'disclaimer.contact': 'Contato',
};

export default common;